module.exports = __webpack_public_path__ + "static/media/terminosycondiciones04082020(es).621074c9.pdf";